import { Feature } from '@entities/featureFlag/ui/Feature';
import { useShowGameMechanics } from '@features/GameMechanics/lib/useShowGameMechanics';
import { GameMechanicsAdvantagesModal } from '@features/GameMechanics/ui/GameMechanicsAdvantagesModal';
import { InteractiveTutorial } from '@features/Tutorial';
import { FC } from 'react';

interface ModalsControllerProps {
  isLoading: boolean;
}

export const ModalsController: FC<ModalsControllerProps> = ({ isLoading }) => {
  const {
    show: showAdvantages,
    handleStart,
    dontShowAgain,
    setDontShowAgain,
  } = useShowGameMechanics();

  return (
    <>
      {(showAdvantages || isLoading) && (
        <GameMechanicsAdvantagesModal
          onStart={handleStart}
          dontShowAgain={dontShowAgain}
          setDontShowAgain={setDontShowAgain}
          showFooter={!isLoading}
        />
      )}
      <Feature feature="showTutorial">
        {(enabled) => {
          if (!showAdvantages && !isLoading && enabled) return <InteractiveTutorial />;
          return null;
        }}
      </Feature>
    </>
  );
};
